<template>
  <AppModal @close="setCloseModal"
            :show="openFromOtherComponent">>
    <h1 slot="header">{{ $t('vue2.editCalendarEditName.edit_name') }}</h1>
    <div slot="body">
      <div class="content">
        <h2>{{ $t('vue2.editCalendarEditName.calendar_name') }}</h2>
        <input type="text"
               v-model="calName"
               @keyup="validateInput"
               :class="{'missing-input': !validateInput()}"/>
      </div>
    </div>
    <div slot="footer"
         class="flex flex-end align-center pad-10">
      <p v-if="!validateInput()" class="warning-text marg-10-right">
        {{ $t('vue2.editCalendarEditName.warning_text') }}
      </p>
      <button v-if="validateInput()"
              @click="submitNewName"
              class="submit-btn">
        {{ $t('vue2.editCalendarEditName.update_name') }}
      </button>
      <button v-else class="submit-btn--disabled">
        {{ $t('vue2.editCalendarEditName.update_name') }}
      </button>
    </div>
  </AppModal>
</template>

<script>
import docendo from '../../docendo'
import eventbus from '../../eventbus'
import AppModal from '../CreateCalendars/Modal'

export default {
  components: {AppModal},
  props: {
    calendar: {
      required: true
    }
  },
  data () {
    return {
      calName: ''
    }
  },
  computed: {
    activeSchool () {
      return this.$store.state.activeSchool
    },
    openFromOtherComponent () {
      return eventbus.editCalendarNameModal
    }
  },
  methods: {
    validateInput () {
      return this.calName && this.calName.length > 0
    },
    setCloseModal () {
      eventbus.editCalendarNameModal = false
    },
    submitNewName () {
      docendo.schoolCalendarsUpdate(
        this.calendar.school_id,
        this.calendar.id,
        {name: this.calName},
        succes => {
          eventbus.toast = {text: this.$t('vue2.editCalendarEditName.success_text'), 'success': true}
          window.location.reload()
        },
        errors => {
          eventbus.toast = {text: this.$t('vue2.toast.something_went_wrong'), 'success': false}
        })
      this.setCloseModal()
    }
  },
  mounted () {
    this.calName = this.calendar ? this.calendar.name : ''
  }
}
</script>

<style scoped>
.flex-end {
  justify-content: flex-end;
}

.content {
  border: 1px solid #cccccc;
  padding: 20px;
  background: white;
}

.missing-input {
  border-color: red
}

.warning-text {
  color: red;
}

.submit-btn--disabled {
  cursor: not-allowed;
  opacity: 0.5;
  background-color: #f6f7f8 !important;
  border: 1px solid #d8d8d8 !important;
}

</style>



// WEBPACK FOOTER //
// EditCalendarEditName.vue?38417235